<mat-icon
  class="ice-info-icon"
  matTooltipClass="custom-ice-tooltip"
  matTooltipPosition="right"
  [class.disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipShowDelay]="200"
  [svgIcon]="IconNames.ice_info"
/>
